<template>
    <v-container>
        <v-row text-center wrap>
            <v-col xs="12">
                <v-card>
                    <v-toolbar flat class="grey lighten-4">
                        <v-toolbar-title>Виртуалы</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="createVirtualPopup"
                            color="success"
                        >
                            Добавить
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-data-table
                            :headers="search.headers"
                            :items="search.data"
                            :loading="search.loading"
                            disable-pagination
                            hide-default-footer
                        >
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td class="text-left">{{ item.id }}</td>
                                    <td class="text-left">{{ item.first_name }} {{ item.middle_name }} {{ item.last_name }}</td>
                                    <td class="text-left">{{ item.email }}</td>
                                    <td class="text-left">{{ item.password }}</td>
                                    <td class="text-left">
                                        <div
                                            v-for="(c) in item.companies"
                                            :key="c.id"
                                        >
                                            <router-link
                                                :to="{name: 'CompanyView', params: {id: c.id}}"
                                            >
                                                <span
                                                    v-if="c.allow && $moment(c.from_date + ' ' + c.from_time).isBefore($moment())"
                                                    class="success--text"
                                                >
                                                    {{ c.name }}
                                                </span>
                                                <span
                                                    v-if="c.allow && !$moment(c.from_date + ' ' + c.from_time).isBefore($moment())"
                                                    class="warning--text"
                                                >
                                                    {{ c.name }}
                                                </span>
                                                <span
                                                    v-if="!c.allow"
                                                    class="error--text"
                                                >
                                                    {{ c.name }}
                                                </span>
                                            </router-link>
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <span v-if="item.access_token && item.access_token.length > 0">Есть</span>
                                        <a
                                            v-else
                                            :href="headHunterAuthorizationUrl(item.id)"
                                            target="_blank"
                                        >
                                            Нет
                                        </a>
                                    </td>
                                    <td class="text-left">
                                        <div class="d-inline-flex align-center">
                                            <v-icon
                                                small
                                                class="mr-2"
                                                @click="updateVirtualPopup(item)"
                                            >
                                                mdi-pencil
                                            </v-icon>
                                            <v-icon
                                                small
                                                @click="removeVirtualPopup(item)"
                                            >
                                                mdi-delete
                                            </v-icon>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog
            v-if="create.show"
            v-model="create.show"
            max-width="500"
        >
            <v-card>
                <v-card-title class="headline">Новый виртуал</v-card-title>
                <v-form
                    @submit.prevent="createVirtual"
                    autocomplete="off"
                >
                    <v-card-text>
                        <v-text-field
                            v-model="create.data.first_name"
                            :error-messages="create.errors.first_name"
                            name="first_name"
                            label="Имя"
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="create.data.middle_name"
                            :error-messages="create.errors.middle_name"
                            name="middle_name"
                            label="Отчество"
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="create.data.last_name"
                            :error-messages="create.errors.last_name"
                            name="last_name"
                            label="Фамилия"
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="create.data.email"
                            :error-messages="create.errors.email"
                            name="email"
                            label="Почта"
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="create.data.password"
                            :error-messages="create.errors.password"
                            name="password"
                            label="Пароль"
                            type="text">
                        </v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="create.show = false"
                            :disabled="create.progress"
                            text
                            color="error"
                        >
                            Отменить
                        </v-btn>
                        <v-btn
                            :loading="create.progress"
                            type="submit"
                            color="primary"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="remove.show"
            v-model="remove.show"
            max-width="600"
        >
            <v-card>
                <v-card-title class="headline">Удалить виртуала {{ remove.data.first_name }} {{ remove.data.middle_name }} {{ remove.data.last_name }}?</v-card-title>
                <v-card-text>
                    <p v-if="remove.errors.id.length" class="mt-5 mb-0 error--text">{{ remove.errors.id[0] }}</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="remove.show = false"
                        :disabled="remove.progress"
                        color="red darken-1"
                        text
                    >
                        Отменить
                    </v-btn>
                    <v-btn
                        @click="removeVirtual"
                        :loading="remove.progress"
                        color="green darken-1"
                        text
                    >
                        Удалить
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="update.show"
            v-model="update.show"
            max-width="500"
        >
            <v-card>
                <v-card-title class="headline">Редактирование виртуала</v-card-title>
                <v-form
                    @submit.prevent="updateVirtual"
                    autocomplete="off"
                >
                    <v-card-text>
                        <v-text-field
                            v-model="update.data.first_name"
                            :error-messages="update.errors.first_name"
                            name="first_name"
                            label="Имя"
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="update.data.middle_name"
                            :error-messages="update.errors.middle_name"
                            name="middle_name"
                            label="Отчество"
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="update.data.last_name"
                            :error-messages="update.errors.last_name"
                            name="last_name"
                            label="Фамилия"
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="update.data.email"
                            :error-messages="update.errors.email"
                            name="email"
                            label="Почта"
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="update.data.password"
                            :error-messages="update.errors.password"
                            name="password"
                            label="Пароль"
                            type="text">
                        </v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="update.show = false"
                            :disabled="update.progress"
                            text
                            color="error"
                        >
                            Отменить
                        </v-btn>
                        <v-btn
                            :loading="update.progress"
                            type="submit"
                            color="primary"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    name: "VirtualController",
    data () {
        return {
            create: {
                data: {
                    first_name: '',
                    middle_name: '',
                    last_name: '',
                    email: '',
                    password: '',
                },
                errors: {
                    first_name: '',
                    middle_name: '',
                    last_name: '',
                    email: '',
                    password: '',
                },
                progress: false,
                show: false,
            },
            remove: {
                data: {
                    id: '',
                    name: '',
                },
                errors: {
                    id: [],
                },
                progress: false,
                show: false,
            },
            search: {
                data: [],
                headers: [
                    {
                        text: 'ID',
                        value: 'id',
                    },
                    {
                        text: 'Имя',
                        value: 'Имя',
                    },
                    {
                        text: 'Почта',
                        value: 'email',
                    },
                    {
                        text: 'Пароль',
                        value: 'password',
                    },
                    {
                        text: 'Компания',
                        value: 'company',
                    },
                    {
                        text: 'Токен',
                        value: 'access_token',
                    },
                    {
                        text: 'Действия',
                        value: 'id',
                    },
                ],
                loading: true,
            },
            update: {
                data: {
                    id: 0,
                    first_name: '',
                    middle_name: '',
                    last_name: '',
                    email: '',
                    password: '',
                },
                errors: {
                    id: '',
                    first_name: '',
                    middle_name: '',
                    last_name: '',
                    email: '',
                    password: '',
                },
                progress: false,
                show: false,
            },
        }
    },
    computed: {
        client_id () {
            return process.env.VUE_APP_API_CLIENT_ID
        },
    },
    created () {
        this.searchVirtuals()
    },
    methods: {
        headHunterAuthorizationUrl (id) {
            const redirectUri = new URL(process.env.VUE_APP_HEADHUNTER_REDIRECT_URI || 'https://admin.profitjob.ru/hh/auth')
            redirectUri.searchParams.set('id', id)

            const authorizationUrl = new URL('https://hh.ru/oauth/authorize')
            authorizationUrl.searchParams.set('response_type', 'code')
            authorizationUrl.searchParams.set('client_id', this.client_id)
            authorizationUrl.searchParams.set('redirect_uri', redirectUri.toString())

            return authorizationUrl.toString()
        },

        createVirtual: function () {
            this.create.progress = true

            this.create.errors.first_name = []
            this.create.errors.middle_name = []
            this.create.errors.last_name = []
            this.create.errors.email = []
            this.create.errors.password = []

            this.$axios.post('/manager/virtual/create', this.create.data)
                .then((res) => {
                    if (res.data.success) {
                        this.create.show = false
                        this.create.data.first_name = ''
                        this.create.data.middle_name = ''
                        this.create.data.last_name = ''
                        this.create.data.email = ''
                        this.create.data.password = ''
                    } else {
                        this.create.errors.first_name = res.data.errors.first_name || []
                        this.create.errors.middle_name = res.data.errors.middle_name || []
                        this.create.errors.last_name = res.data.errors.last_name || []
                        this.create.errors.email = res.data.errors.email || []
                        this.create.errors.password = res.data.errors.password || []
                    }

                    this.create.progress = false

                    this.searchVirtuals()
                })
                .catch(() => {
                    this.create.progress = false
                })
        },

        createVirtualPopup: function () {
            this.create.show = true
        },

        removeVirtual () {
            this.remove.progress = true
            this.remove.errors.id = []

            this.$axios.post('/manager/virtual/remove', this.remove.data)
                .then((res) => {
                    if (res.data.success) {
                        this.remove.show = false
                        this.remove.data.id = 0
                        this.remove.data.name = ''

                        this.searchVirtuals()
                    } else {
                        this.remove.errors.id = res.data.errors.id || []
                    }

                    this.remove.progress = false
                })
                .catch(() => {
                    this.remove.progress = false
                })
        },

        removeVirtualPopup (virtual) {
            this.remove.errors.id = []
            this.remove.data.id = virtual.id
            this.remove.data.first_name = virtual.first_name
            this.remove.data.middle_name = virtual.middle_name
            this.remove.data.last_name = virtual.last_name
            this.remove.show = true
        },

        searchVirtuals () {
            this.search.loading = true

            this.$axios.post('/manager/virtual/search')
                .then(res => {
                    if (res.data.success) {
                        this.search.data = res.data.data
                    }

                    this.search.loading = false
                })
                .catch(() => {
                    this.search.loading = false
                })
        },

        updateVirtual: function () {
            this.update.progress = true

            this.update.errors.id = []
            this.update.errors.first_name = []
            this.update.errors.middle_name = []
            this.update.errors.last_name = []
            this.update.errors.email = []
            this.update.errors.password = []

            this.$axios.post('/manager/virtual/update', this.update.data)
                .then((res) => {
                    if (res.data.success) {
                        this.update.show = false
                        this.update.data.id = 0
                        this.update.data.first_name = ''
                        this.update.data.middle_name = ''
                        this.update.data.last_name = ''
                        this.update.data.email = ''
                        this.update.data.password = ''
                    } else {
                        this.update.errors.id = res.data.errors.id || []
                        this.update.errors.first_name = res.data.errors.first_name || []
                        this.update.errors.middle_name = res.data.errors.middle_name || []
                        this.update.errors.last_name = res.data.errors.last_name || []
                        this.update.errors.email = res.data.errors.email || []
                        this.update.errors.password = res.data.errors.password || []
                    }

                    this.update.progress = false

                    this.searchVirtuals()
                })
                .catch(() => {
                    this.update.progress = false
                })
        },

        updateVirtualPopup (virtual) {
            this.update.data.id = virtual.id
            this.update.data.first_name = virtual.first_name
            this.update.data.middle_name = virtual.middle_name
            this.update.data.last_name = virtual.last_name
            this.update.data.email = virtual.email
            this.update.data.password = virtual.password
            this.update.show = true
        },
    },
}
</script>
